import { render } from "./ListadoPublicaciones.vue?vue&type=template&id=570df34c&scoped=true"
import script from "./ListadoPublicaciones.vue?vue&type=script&lang=js"
export * from "./ListadoPublicaciones.vue?vue&type=script&lang=js"

import "./ListadoPublicaciones.vue?vue&type=style&index=0&id=570df34c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570df34c"]])

export default __exports__